const form_datatype = {
  consentTerm: "boolean",
  contactEmail: "string",
  contactRoles: "string",
  contactLastName: "string",
  contactFirstName: "string",
  contactPhoneNumber: "string",
  contactRelationship: "string",
  insuranceTerm: "boolean",
  privacyConsentTerm: "boolean",
  baseChargeTerm: "boolean",
  arbitrationTerm: "boolean",
  lateChargesTerm: "boolean",
  startDate: "string",
  specialRequests: "string",
  caregiverPreference: "string",
  billingPoliciesTerm: "boolean",
  dental: "string",
  speech: "string",
  vision: "string",
  hearing: "string",
  fallRisk: "string",
  continence: "string",
  swallowing: "string",
  oxygenDependent: "string",
  medicalDiagnosis: "string",
  isMedicationReminders: "string",
  isShoweringAssistance: "string",
  nonSolicitationTerm: "boolean",
  cancellationFeesTerm: "boolean",
  hospitalizationTerm: "boolean",
  cancellationWithAtLeastFourHoursTerm: "boolean",
  cancellationWithLessThanFourHoursTerm: "boolean",
  wanders: "boolean",
  agitation: "boolean",
  combative: "boolean",
  confusion: "boolean",
  upAtNight: "boolean",
  withdrawn: "boolean",
  suspicious: "boolean",
  gender: "string",
  weight: "number",
  lastName: "string",
  firstName: "string",
  heightFeet: "number",
  dateOfBirth: "string",
  phoneNumber: "string",
  heightInches: "number",
  hospiceAgency: "string",
  hospiceStatus: "boolean",
  hospiceRepName: "string",
  hospiceRepPhone: "string",
  homeHealthStatus: "boolean",
  usesWheelchair: "boolean",
  sendMethod: "string",
  billingCity: "string",
  billingState: "string",
  recipientType: "string",
  billingZipCode: "string",
  billingContactEmail: "string",
  billingContactPhone: "string",
  billingStreetAddress: "string",
  billingContactLastName: "string",
  billingContactFirstName: "string",
  holidaysAndOvertimeTerm: "boolean",
  mileageReimbursementTerm: "boolean",
  physicianLastName: "string",
  physicianFirstName: "string",
  physicianPhoneNumber: "string",
  allergies: "string",
  allergiesNote: "string",
  learnMore: "string",
  petsPresent: "boolean",
  firearmsSecure: "string",
  firearmsPresent: "boolean",
  smokingEnvironment: "boolean",
  longTermCareInsurance: "boolean",
  dnrLocation: "string",
  documentDNR: "boolean",
  city: "string",
  fillersPhone: "string",
  fillersFirstName: "string",
  fillersLastName: "string",
  communityLiaison: "string",
  Signature: "string",
  ispAdditionalSigner: "string",
  isFillingForSomeoneElse: "string",
  limitationOfLiabilityTerm: "boolean",
  additionalInfo: "string",
  notes: "string",
  baseRate: "number",
  bankName: "string",
  accountNumber: "string",
  routingNumber: "string",
  accountHolderName: "string",
  paymentMethod: "string",
  serviceType: "string",
  feeAcknowledgment: "boolean",
  homePhone: "string",
  mobilePhone: "string",
  preferredPhone: "string",
  serviceAddressCity: "string",
  serviceAddressState: "string",
  serviceAddressStreet: "string",
  serviceAddress1: "string",
  serviceAddressZipCode: "string",
  days: "string",
  endTime: "string",
  startTime: "string",
  showTimes: "boolean",
  scheduleType: "string",
  eating: "boolean",
  bathing: "boolean",
  assistanceEatingNotes: "string",
  toileting: "boolean",
  mealPreparation: "boolean",
  dressingGrooming: "boolean",
  housework: "boolean",
  companionship: "boolean",
  transportationNeeded: "boolean",
  other: "boolean",
  documentMPOA: "boolean",
  petType: "string",
  petWeight: "string",
  size: "string",
  policyNumber: "string",
  ltcInsuranceProvider: "string",
  ltcInsuranceAcknowledgment: "boolean",
  stearRegistration: "boolean",
  isOralHygieneAssistance: "string",
  walker: "string",
  isMealtimeAssistance: "string",
  isMealtimeAssistanceLevel: "string",
  combativeNotes: "string",
  wandersNotes: "string",
  withdrawnNotes: "string",
  upAtNightNotes: "string",
  suspiciousNotes: "string",
  agitationNotes: "string",
  confusionNotes: "string",
  overtimeAgreementTerm: "boolean",
  obligationOfResponsiblePartyTerm: "boolean",
  authorizationToTransfer: "boolean",
};

export default form_datatype;
